import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=2d87b344&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/richarddavies/Documents/GitHub/Envy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d87b344')) {
      api.createRecord('2d87b344', component.options)
    } else {
      api.reload('2d87b344', component.options)
    }
    module.hot.accept("./Video.vue?vue&type=template&id=2d87b344&", function () {
      api.rerender('2d87b344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/javascripts/components/Video.vue"
export default component.exports